<template>
    <MainContent title="Editar remitente">
        <template v-slot:header>
            <h3 class="card-title mb-3">Editar remitente</h3>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <FormRemitente v-if="remitente" :remitente="remitente" :loading="loading" @terminado="editarRemitente" />
            </ContentOrLoading>
        </template>
    </MainContent>
</template>

<script>
    import apiService from '@/services/api-comunicados';
    import MainContent from '@/components/backend/components/MainContent';
    import FormRemitente from '@/components/backend/campana-emails/remitentes/FormRemitente';

    export default {
        props: ['remitente_id'],
        data() {
            return {
                remitente: null,
                loading: false
            }
        },
        methods: {
            async getRemitente() {
                this.loading = true;

                try {
                    const response = await apiService.getRemitente(this.remitente_id);
                    this.remitente = response.data;
                } catch (error) {
                    console.error('Error al cargar remitente:', error);
                } finally {
                    this.loading = false;
                }
            },
            async editarRemitente(data) {
                this.loading = true;

                try {
                    await apiService.updateRemitente(this.remitente_id, data);
                    this.$toast.success('Remitente editado correctamente');
                    this.$router.push('/admin/emails/remitentes');
                } catch (error) {
                    console.error('Error al actualizar remitente:', error);
                } finally {
                    this.loading = false;
                }
            }
        },
        created() {
            this.getRemitente();
        },
        components: {
            MainContent, FormRemitente
        }
    }
</script>